import React from "react";
import Logo from "../../assets/white-logo.png";
import Instagram from "../../assets/Instagram.png";
import "./footer.css";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

const Footer = () => {
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      {isTablet ? (
        // <>
        <div className="footer-container">
          <div className="footer-left">
            <div className="logo-col">
              <div className="logo-box">
                <img src={Logo} alt="Logo" />
              </div>
              <div className="social-box">
                <div className="icon">
                  <a
                    href="https://www.facebook.com/CreativeScaleLab"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_548_469)">
                        <path
                          d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 16.84 5.44 20.87 10 21.8V15H8V12H10V9.5C10 7.57 11.57 6 13.5 6H16V9H14C13.45 9 13 9.45 13 10V12H16V15H13V21.95C18.05 21.45 22 17.19 22 12Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_548_469">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
                <div className="icon">
                  <a
                    href="https://www.instagram.com/creativescale_lab?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={Instagram} alt="Instagram" />
                  </a>
                </div>
              </div>
            </div>
            <div className="copywrite">
              <p>© 2024 CSL Agency - All Rights Reserved</p>
            </div>
          </div>
          <div className="footer-right">
            <div className="footer-right-top">
              <div className="explore">
                <h5>Explore</h5>
                <ul>
                  <Link to="/about" onClick={handleClick}>
                    <li>About Us</li>
                  </Link>
                  <Link to="/work" onClick={handleClick}>
                    <li>Work With Us</li>
                  </Link>
                  <Link to="/contact" onClick={handleClick}>
                    <li>Contact Us</li>
                  </Link>
                </ul>
              </div>
              <div className="resources">
                <h5>Resources</h5>
                <ul>
                  <Link to="/about" onClick={handleClick}>
                    <li>Blog</li>
                  </Link>
                  <Link to="/about" onClick={handleClick}>
                    <li>Portfolio</li>
                  </Link>
                  <Link to="/faqs" onClick={handleClick}>
                    <li>FAQ</li>
                  </Link>
                </ul>
              </div>
              <div className="services-col">
                <h5>Services</h5>
                <ul>
                  <Link to="/webDesign" onClick={handleClick}>
                    <li>UI/UX</li>
                  </Link>
                  <Link to="/webDesign" onClick={handleClick}>
                    <li>SEO & SEM</li>
                  </Link>
                  <Link to="/webDesign" onClick={handleClick}>
                    <li>Video Editing</li>
                  </Link>
                </ul>
              </div>
            </div>
            <div className="contact-col">
              <h5>Stay Ahead in Digital Marketing!</h5>
              <p>
                Subscribe to our newsletter for the latest digital marketing
                tips, trends, and exclusive offers!
              </p>
              <form className="newsletter-form">
                <input
                  type="email"
                  placeholder="Write your email"
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-submit">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="footer-container">
            <div className="logo-col">
              <div className="logo-box">
                <img src={Logo} alt="Logo" />
              </div>
              <div className="social-box">
                <div className="icon">
                  <a
                    href="https://www.facebook.com/CreativeScaleLab"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_548_469)">
                        <path
                          d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 16.84 5.44 20.87 10 21.8V15H8V12H10V9.5C10 7.57 11.57 6 13.5 6H16V9H14C13.45 9 13 9.45 13 10V12H16V15H13V21.95C18.05 21.45 22 17.19 22 12Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_548_469">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
                <div className="icon">
                  <a
                    href="https://www.instagram.com/creativescale_lab?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={Instagram} alt="Instagram" />
                  </a>
                </div>
              </div>
            </div>
            <div className="explore">
              <h5>Explore</h5>
              <ul>
                <Link to="/about" onClick={handleClick}>
                  <li>About Us</li>
                </Link>
                <Link to="/work" onClick={handleClick}>
                  <li>Work With Us</li>
                </Link>
                <Link to="/contact" onClick={handleClick}>
                  <li>Contact Us</li>
                </Link>
              </ul>
            </div>
            <div className="resources">
              <h5>Resources</h5>
              <ul>
                <Link to="/about" onClick={handleClick}>
                  <li>Blog</li>
                </Link>
                <Link to="/about" onClick={handleClick}>
                  <li>Portfolio</li>
                </Link>
                <Link to="/faqs" onClick={handleClick}>
                  <li>FAQ</li>
                </Link>
              </ul>
            </div>
            <div className="services-col">
              <h5>Services</h5>
              <ul>
                <Link to="/webDesign" onClick={handleClick}>
                  <li>UI/UX</li>
                </Link>
                <Link to="/webDesign" onClick={handleClick}>
                  <li>SEO & SEM</li>
                </Link>
                <Link to="/webDesign" onClick={handleClick}>
                  <li>Video Editing</li>
                </Link>
              </ul>
            </div>
            <div className="contact-col">
              <h5>Stay Ahead in Digital Marketing!</h5>
              <p>
                Subscribe to our newsletter for the latest digital marketing
                tips, trends, and exclusive offers!
              </p>
              <form className="newsletter-form">
                <input
                  type="email"
                  placeholder="Write your email"
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-submit">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
          <div className="copywrite">
            <p>© 2024 CSL Agency - All Rights Reserved</p>
          </div>
        </>
      )}
    </footer>
  );
};

export default Footer;
